import type { QueryReplacer } from '.';

export const DrillReplacer: QueryReplacer = {
    regex: /\{drills\}/,
    replace: (statement, _metadata, _filterValues, regexMatches, settings) => {
        const value = settings.DATABRICKS_DRILL
            ? settings.DATABRICKS_DRILL.map(item => item.key).join(',')
            : '';

        return regexMatches.reduce((pre, cur) => pre.replace(cur.exact, value), statement);
    },
};
